import { canRead, canWrite } from '../access/rbacAccess'

export const REFUNDS = {
  LIST: 'ejecuta.refunds',
  APPROVAL: 'ejecuta.refunds.show.refund_approval_rejected',
  PROCESS_ERP: 'ejecuta.refunds.show.refund_process_code_erp'
}

export const canViewRefunds = () => canRead(REFUNDS.LIST)

export const hasRefundApprovalReadAccess = () => canRead(REFUNDS.APPROVAL)

export const hasRefundHistoryReadAccess = () =>
  hasRefundApprovalReadAccess() || hasRefundProcessCodeErpReadAccess()

export const isRefundApprovalWorkflowEnabled = () =>
  hasRefundApprovalReadAccess() || hasRefundProcessCodeErpReadAccess()

export const canApproveRefunds = () => canWrite(REFUNDS.APPROVAL)

export const canCountRefunds = () => canApproveRefunds()

export const canProcessRefundCodeErp = () => canWrite(REFUNDS.PROCESS_ERP)

export const hasRefundProcessCodeErpReadAccess = () => canRead(REFUNDS.PROCESS_ERP)

export const isRefundSupervisorView = () => canApproveRefunds() && canProcessRefundCodeErp()

export const isRefundLiquidadorView = () => canApproveRefunds() && !canProcessRefundCodeErp()

export const isRefundProcesadorView = () => canProcessRefundCodeErp() && !canApproveRefunds()

export const isRefundBaseListView = () =>
  canViewRefunds() && !hasRefundApprovalReadAccess() && !hasRefundProcessCodeErpReadAccess()

export const showRefundNcrColumn = () => isRefundProcesadorView() || isRefundSupervisorView()
